import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    actions: {
        id: 'iaso.label.actions',
        defaultMessage: 'Action(s)',
    },
    addParameters: {
        id: 'iaso.label.addParameters',
        defaultMessage: 'Add parameters',
    },
    algorithm: {
        id: 'iaso.label.algorithm',
        defaultMessage: 'Algorithm',
    },
    algorithmsUsed: {
        id: 'iaso.label.algorithmsUsed',
        defaultMessage: 'Algorithms used',
    },
    algorithmRuns: {
        id: 'iaso.label.algorithmsRuns',
        defaultMessage: 'Algorithms runs',
    },
    analysisBusy: {
        defaultMessage: 'Analysis in progress',
        id: 'iaso.duplicate.analysisBusy',
    },
    alreadyIgnored: {
        id: 'iaso.label.alreadyIgnored',
        defaultMessage: 'Already ignored',
    },
    alreadyMerged: {
        id: 'iaso.label.alreadyMerged',
        defaultMessage: 'Already merged',
    },
    cancel: {
        defaultMessage: 'Cancel',
        id: 'iaso.label.cancel',
    },
    compareDuplicates: {
        id: 'iaso.label.compareDuplicates',
        defaultMessage: 'Compare duplicates',
    },
    comparedFields: {
        id: 'iaso.label.comparedFields',
        defaultMessage: 'Compared fields',
    },
    confirm: {
        defaultMessage: 'Confirm',
        id: 'iaso.label.confirm',
    },
    created_at: {
        id: 'iaso.forms.created_at',
        defaultMessage: 'Created',
    },
    duplicateAnalyses: {
        id: 'iaso.label.duplicateAnalyses',
        defaultMessage: 'Duplicate Analyses',
    },
    duplicateNotFound: {
        id: 'iaso.duplicate.notFound',
        defaultMessage: 'Duplicate not found or already processed',
    },
    duplicates: {
        id: 'iaso.label.duplicates',
        defaultMessage: 'Duplicates',
    },
    endDateUntil: {
        id: 'iaso.label.endDateUntil',
        defaultMessage: 'End date until',
    },
    entities: {
        id: 'iaso.entities.title',
        defaultMessage: 'Entities',
    },
    entityA: {
        id: 'iaso.label.entityA',
        defaultMessage: 'Entity A',
    },
    entityB: {
        id: 'iaso.label.entityB',
        defaultMessage: 'Entity B',
    },
    entityType: {
        id: 'iaso.entityTypes.label',
        defaultMessage: 'Entity type',
    },
    entityTypes: {
        id: 'iaso.entityTypes.title',
        defaultMessage: 'Entity types',
    },
    field: {
        id: 'iaso.label.field',
        defaultMessage: 'Field',
    },
    fields: {
        id: 'iaso.label.fields',
        defaultMessage: 'Fields',
    },
    finalValue: {
        id: 'iaso.label.finalValue',
        defaultMessage: 'Final value',
    },
    finished_at: {
        id: 'iaso.label.finished_at',
        defaultMessage: 'Finished at',
    },
    form: {
        id: 'iaso.instance.formShort',
        defaultMessage: 'Form',
    },
    ignore: {
        id: 'iaso.label.ignore',
        defaultMessage: 'Ignore',
    },
    ignoreSelectionMessage: {
        defaultMessage: 'Are you sure you wish to ignore selected duplicates?',
        id: 'iaso.duplicate.ignoreSelectionMessage',
    },
    ignoreSelectionTitle: {
        defaultMessage: 'Ignore selection?',
        id: 'iaso.duplicate.ignoreSelectionTitle',
    },
    latestAnalysis: {
        defaultMessage: 'Latest analysis completed: {finishedAt}',
        id: 'iaso.duplicate.latestAnalysis',
    },
    launchAnalysis: {
        defaultMessage: 'Launch analysis',
        id: 'iaso.duplicate.launchAnalysis',
    },
    location: {
        id: 'iaso.forms.location',
        defaultMessage: 'Location',
    },
    merge: {
        id: 'iaso.label.merge',
        defaultMessage: 'Merge',
    },
    messageErrorMissingFields: {
        defaultMessage:
            'No fields to analyse. You can set them up in the entities types page',
        id: 'iaso.duplicate.messageErrorMissingFields',
    },
    noAnalysis: {
        defaultMessage: 'No analysis found',
        id: 'iaso.duplicate.noAnalysis',
    },
    noSubmissionFound: {
        defaultMessage: 'No submission found',
        id: 'iaso.entity.label.noSubmissionFound',
    },
    parameters: {
        id: 'iaso.label.parameters',
        defaultMessage: 'Parameters',
    },
    parameterValue: {
        id: 'iaso.label.parameterValue',
        defaultMessage: 'Parameter Value',
    },
    relaunchAnalysis: {
        defaultMessage: 'Relaunch Analysis',
        id: 'iaso.duplicate.relaunchAnalysis',
    },
    removeParameter: {
        id: 'iaso.label.removeParameter',
        defaultMessage: 'Remove parameter',
    },
    reset: {
        id: 'iaso.storages.reset',
        defaultMessage: 'Reset',
    },
    result_message: {
        id: 'iaso.label.result_message',
        defaultMessage: 'Result Message',
    },
    search: {
        id: 'iaso.search',
        defaultMessage: 'Search',
    },
    seeDetails: {
        id: 'iaso.label.seeDetails',
        defaultMessage: 'See details',
    },
    showIgnored: {
        id: 'iaso.label.showIgnored',
        defaultMessage: 'Show ignored',
    },
    showMerged: {
        id: 'iaso.label.showMerged',
        defaultMessage: 'Show merged',
    },
    showUnmatchedOnly: {
        id: 'iaso.label.showUnmatchedOnly',
        defaultMessage: 'Show unmatched fields only',
    },
    similarity: {
        id: 'iaso.label.similarity_score',
        defaultMessage: 'Similarity score',
    },
    similarityScore: {
        id: 'iaso.label.similarity_score',
        defaultMessage: 'Similarity score',
    },
    softDeleteA: {
        id: 'iaso.label.entities.deleteA',
        defaultMessage: 'Delete entity A',
    },
    softDeleteB: {
        id: 'iaso.label.entities.deleteB',
        defaultMessage: 'Delete entity B',
    },
    startDatefrom: {
        id: 'iaso.label.startDatefrom',
        defaultMessage: 'Start date from',
    },
    status: {
        id: 'iaso.label.status',
        defaultMessage: 'Status',
    },
    submissionTitle: {
        defaultMessage: 'Submission',
        id: 'iaso.instance.titleSingle',
    },
    submissionsForEntity: {
        defaultMessage: 'Submissions for entity {entity}',
        id: 'iaso.entity.label.submissionsForEntity',
    },
    submitter: {
        id: 'iaso.label.submitter',
        defaultMessage: 'Submitter',
    },
    submitterTeam: {
        id: 'iaso.label.submitterTeam',
        defaultMessage: 'Submitter team',
    },
    takeValuesFromA: {
        id: 'iaso.label.entities.takeValuesFromA',
        defaultMessage: 'Take all values from A',
    },
    takeValuesFromB: {
        id: 'iaso.label.entities.takeValuesFromB',
        defaultMessage: 'Take all values from B',
    },
    unmatchedRemaining: {
        id: 'iaso.label.unmatchedRemaining',
        defaultMessage: 'Unmatched fields remaining',
    },
    user: {
        defaultMessage: 'User',
        id: 'iaso.label.user',
    },
});

export default MESSAGES;
